import physicalDamageIcon from '../styles/svgs/coverages/physical_damage.svg';
import mtplIcon from '../styles/svgs/coverages/mtpl.svg';
import personalAccidentIcon from '../styles/svgs/coverages/personal_accident.svg';
import carAmbulanceIcon from '../styles/svgs/coverages/car_ambulance.svg';

export const MONTHS = {
  MIN: 3,
  MAX: 12,
};

export const OWN_USE_TYPE = {
  id: 1,
  value: 1,
};

export const DURATION_TYPES = {
  MONTH: 'month',
  DAY: 'day',
};

export const SEATS = {
  FOUR: 4,
  FIVE: 5,
  SEVEN: 7,
};

export const DEFAULT_SEAT_COUNT = 0;

export const CMTPL_EMPTY_PRICES = {
  main: null,
  twelveMonths: null,
  sixMonths: null,
  threeMonths: null,
};

export const CMTPL_CASCO_EMPTY_PRICES = {
  standard: {
    covsum: null,
    coverages: {
      damage: null,
      mtpl: null,
      accident: null,
      ambulance: null,
    },
  },
};

const initialCoverages = {
  damage: null,
  mtpl: null,
  accident: null,
  ambulance: null,
}
const CMTPL_CASCO_INITIAL_DATA = {
  standard: {
    single: { ...initialCoverages },
    monthly: { ...initialCoverages },
    semiannual: { ...initialCoverages },
    quarterly: { ...initialCoverages },
  },
};

export const CMTPL_CASCO_EMPTY_DISCOUNTS = { ...CMTPL_CASCO_INITIAL_DATA };

export const CMTPL_CASCO_EMPTY_AMOUNTS = { ...CMTPL_CASCO_INITIAL_DATA };

// Take into account that actually casco is damage key only
export const CMTPL_CASCO_PLANS = {
  standard: {
    id: 'standard',
    label: 'standard',
    descriptions: [],
    warnings: [],
    headColor: 'blue',
    coverages: {
      damage: {
        id: 'damage',
        label: 'damage',
        active: false,
        icon: physicalDamageIcon,
      },
      mtpl: {
        id: 'mtpl',
        label: 'mtpl',
        active: false,
        icon: mtplIcon,
      },
      accident: {
        id: 'accident',
        label: 'accident',
        active: false,
        icon: personalAccidentIcon,
      },
      ambulance: {
        id: 'ambulance',
        label: 'ambulance',
        active: false,
        icon: carAmbulanceIcon,
      },
    },
  },
};

export const POLICY_HOLDER_TYPES = {
  INDIVIDUAL: 'INDVD',
  LEGAL: 'LEGAL',
};

export const CMTPL_CASCO_PRICE_KEYS = {
  COV_SUM: 'covsum',
};

export const CMTPL_CASCO_DISCOUNT_KEYS = {
  COV_DISCOUNT: 'covdiscount',
};

export const CASCO_COVERAGES = {
  damage: {
    id: CMTPL_CASCO_PLANS.standard.coverages.damage.id,
    active: CMTPL_CASCO_PLANS.standard.coverages.damage.active,
  },
  mtpl: {
    id: CMTPL_CASCO_PLANS.standard.coverages.mtpl.id,
    active: CMTPL_CASCO_PLANS.standard.coverages.mtpl.active,
  },
  accident: {
    id: CMTPL_CASCO_PLANS.standard.coverages.accident.id,
    active: CMTPL_CASCO_PLANS.standard.coverages.accident.active,
  },
  ambulance: {
    id: CMTPL_CASCO_PLANS.standard.coverages.ambulance.id,
    active: CMTPL_CASCO_PLANS.standard.coverages.ambulance.active,
  },
};

export const CMTPL_CALCULATOR_PRICE_SECTION_OPTIONS = {
  basePrice: {
    translation: 'cmtplCasco.base.standard',
    showPrice: true,
  },
  finalPrice: {
    translation: 'cmtplCasco.additionalCoverages',
    showPrice: true,
  },
  overallPrice: {
    showPrice: true,
    translation: 'cmtplCasco.overall',
  },
  discount: {
    showPrice: true,
    translation: 'cmtplCasco.discount',
  },
};
